import React from 'react';
import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { createI18nT } from '../i18n.js';

export const previewCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  const t = createI18nT();

  return createCommand('preview')
    .description(t('site_preview_command_def.description'))
    .action(async (options, command) => {
      const { renderCommand } = await import('./render-command.js');
      const { PreviewCommand } = await import(
        '../components/PreviewCommand/PreviewCommand.js'
      );

      await renderCommand(command, services, cliVersion, <PreviewCommand />);
    });
};
